export default {
    methods: {
        isEmail() {
            return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.value))
        },
        isEmpty() {
            return this.value === "" || this.value === null
        },
        isCmsPassword() {
            return (/^(?=.*[A-Z])(?=.*\d.*)[a-zA-Z0-9\S]{8,20}$/.test(this.value))
        },
        exceedsMaxLength() {
            return this.value && this.value.length > this.maxlength
        },
        numericOnly() {
            return (/^\d+$/.test(this.value))
        }
    }
};